import React, { forwardRef, useImperativeHandle, useRef } from "react";
import { IconButton, Link } from "@mui/material";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { FileInterface } from "./SavFormCommentsComponent";
import CancelIcon from "@mui/icons-material/Cancel";
import { useTranslation } from "react-i18next";

const SavFormCommentFileComponent = React.memo(
  forwardRef((props, ref) => {
    const { t } = useTranslation();
    const [files, setFiles] = React.useState<(FileInterface | undefined)[]>([]);
    const fileInputRef = useRef<any>(null);
    const addFile = React.useCallback((event: any) => {
      const thisFiles = Array.from(event.target.files);
      const [file] = thisFiles;
      setFiles((x) => {
        if (!x) {
          x = [];
        }
        x.push({
          ref: React.createRef(),
          // @ts-ignore
          file: file,
        });
        return [...x];
      });
      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }
    }, []);

    useImperativeHandle(ref, () => ({
      getValue() {
        return files.filter((f) => f) as FileInterface[];
      },
      setFiles(newValue: (FileInterface | undefined)[]) {
        setFiles(newValue);
      },
    }));

    return (
      <>
        {files.map((file, index) => (
          <Box key={index}>
            {file?.file && (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Link
                  href={URL.createObjectURL(file.file)}
                  target="_blank"
                  rel="noreferrer"
                >
                  <Typography>{file.file.name ?? ""}</Typography>
                </Link>
                <IconButton
                  onClick={() => {
                    setFiles((f) => {
                      f[index] = undefined;
                      return [...f];
                    });
                  }}
                >
                  <CancelIcon />
                </IconButton>
              </Box>
            )}
          </Box>
        ))}
        <Box sx={{ textAlign: "center" }}>
          <Button variant="contained" component="label">
            {t("word.addFile")}
            <input type="file" hidden onChange={addFile} ref={fileInputRef} />
          </Button>
        </Box>
      </>
    );
  })
);

export default SavFormCommentFileComponent;
